import { render } from "./GraficoMultiplesFaenasDiaOrpNaturalOzonizado.vue?vue&type=template&id=9cb8fc54"
import script from "./GraficoMultiplesFaenasDiaOrpNaturalOzonizado.vue?vue&type=script&lang=js"
export * from "./GraficoMultiplesFaenasDiaOrpNaturalOzonizado.vue?vue&type=script&lang=js"

import exportComponent from "/home/nodejs/front/monitor/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__